angular
  .module('deskfy.arts')
  .controller('ArtListController', ArtListController)

/* @ngInject */
function ArtListController ($scope, $q, $translate, $state, $rootScope, $location, $stateParams, ArtsService, MessageService, ModalService, ProductsService, ToastService, UdsModalService, AssetPreviewService, SelectMaterialCollectionService) {
  const getShareArtDialogController = () => $q.when(import('../../dialogs/share-art/share-art-dialog.controller'))
  const getArtSizeDialogController = () => $q.when(import('../../dialogs/art-size/art-size-dialog.controller'))
  const getMoveArtToFolderController = () => $q.when(import('../../dialogs/move-art-to-folder/move-art-to-folder-dialog.controller'))

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.iCurrentTop = 20
  $scope.iTokensCount = $rootScope.isDesktop ? 3 : 5
  $scope.selectedFolderId = null
  $scope.selectedFolder = null
  $scope.folderForm = {
    newFolderName: ''
  }
  $scope.artsBeingShown = ''

  $scope.flags = {
    loading: false
  }

  $scope.aFolders = []
  $scope.mTemplates = {}
  $scope.mProducts = {}

  $scope.templateOptions = {
    archive: true,
    share: true,
    publish: true,
    duplicate: true,
    approval: true,
    customize: true
  }
  $scope.location = 'materialsCustomizations'
  $scope.selectedTemplates = []
  $scope.floatingBarLocation = 'artList'

  const api = {
    getShareArtDialogController,
    getArtSizeDialogController,
    getMoveArtToFolderController,
    _skipPagingTo,
    _keepOnSamePage,
    _checkIfPageExists,
    _openArtApproval,
    _moveArtToFolder,
    _unselectAllAssets,
    _handleKeyboardNavigation,
    _handleNavigateThroughKeyboard
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._keepOnSamePage($state.params)
      .then(() => {
        if ($stateParams && $stateParams.art) {
          api._openArtApproval($stateParams.art)
        }
      })

    api._handleKeyboardNavigation()
  }

  const deregisterReloadArtsPage = $scope.$on('reload-arts-page', () => {
    getUserFolders()
    if ($scope.arts && $scope.arts.length > 1) {
      api._skipPagingTo($state.params.page, true)
    } else {
      showOwnArts(true)
    }
  })

  const deregisterArtsReloadMyArts = $rootScope.$on('arts.reload-my-arts', () => {
    showOwnArts()
  })

  const deregisterClearFilters = $scope.$on('clearFilters', function () {
    $scope.selectedFolderId = null
    $scope.selectedFolder = null

    ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
      .then(handleGetArtsResponse)
      .catch(handleGetArtsError)
  })

  const deregisterReloadApprovalList = $rootScope.$on('reload-approval-list', () => {
    ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
      .then(handleGetArtsResponse)
      .catch(handleGetArtsError)
  })

  $scope.$on('$destroy', () => {
    deregisterReloadArtsPage()
    deregisterArtsReloadMyArts()
    deregisterClearFilters()
    deregisterReloadApprovalList()
    document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
  })

  $scope.showCustomizableTag = () => {
    return !$rootScope.isUser()
  }

  function setArtsAndResync (oRes) {
    $scope.artsCount = oRes.d.__count
    const arts = oRes.d.results

    api._checkIfPageExists($scope.artsCount, $scope.iCurrentTop)
    arts.forEach(art => {
      if (!art?.isCustomizable) {
        ArtsService.getArtDetailById(art.id).then(details => {
          art.isCustomizable = details?.isCustomizable
        })
      }
    })

    $scope.arts = arts
    $scope.flags.loading = false

    function getInfoId (oArt) {
      return {
        templateId: oArt.baseTemplateId,
        productId: oArt.productId
      }
    }
    function filterInfo (info) {
      return info.templateId || info.productId
    }

    $scope.arts.map(getInfoId).filter(filterInfo).forEach(function (info) {
      if (info.templateId && !$scope.mTemplates[info.templateId]) {
        ArtsService.getArtDetailById(info.templateId).then(function (result) {
          $scope.mTemplates[info.templateId] = result
        })
      }

      if (info.productId && !$scope.mProducts[info.productId]) {
        ProductsService.getProductById(info.productId).then(function (result) {
          $scope.mProducts[info.productId] = result
        })
      }
    })
  }

  function handleGetArtsResponse (oRes) {
    setArtsAndResync(oRes)
  }
  function handleGetArtsError (oResponse) {
    ToastService.defaultErrorToast()
    $scope.flags.loading = false
  }

  function showOwnArts (backToFirstPage) {
    api._unselectAllAssets()
    $scope.flags.loading = true
    $scope.selectedFolderId = null
    $scope.selectedFolder = null
    $scope.artsBeingShown = 'userDashboardArts'
    $scope.floatingBarLocation = 'artList'

    if (backToFirstPage) {
      $location.search({ page: 1 })
    }

    ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
      .then(handleGetArtsResponse)
      .catch(handleGetArtsError)
  }
  showOwnArts()

  $scope.goToArtsPage = function () {
    $state.go('arts.templates')
  }

  $scope.showShared = function () {
    $scope.flags.loading = true
    $scope.selectedFolderId = null
    if ($scope.artsBeingShown === 'sharedArts') {
      showOwnArts()
      return
    }
    $scope.selectedFolder = {
      name: $translate.instant('dashboard.sharedArts')
    }

    $scope.selectType = null
    $scope.artsBeingShown = 'sharedArts'
    $scope.floatingBarLocation = 'sharedArtList'

    function handleGetSharedArtsResponse (oRes) {
      setArtsAndResync(oRes)
    }

    function handleGetSharedArtsError (oRes) {
      $scope.flags.loading = false
      // TODO
    }

    ArtsService.getSharedArts($scope.iCurrentTop, 0)
      .then(handleGetSharedArtsResponse)
      .catch(handleGetSharedArtsError)
  }

  $scope.showArchived = function () {
    $scope.flags.loading = true
    $scope.selectedFolderId = null
    if ($scope.artsBeingShown === 'userArchivedArts') {
      showOwnArts()
      return
    }
    $scope.selectedFolder = {
      name: $translate.instant('dashboard.archivedArts')
    }
    $scope.artsBeingShown = 'userArchivedArts'
    $scope.floatingBarLocation = 'archivedArtList'

    function handleGetArchivedArtsResponse (oRes) {
      setArtsAndResync(oRes)
    }

    function handleGetArchivedArtsError (oRes) {
      $scope.flags.loading = false
      // TODO
    }

    ArtsService.getArchivedArts($scope.iCurrentTop, 0)
      .then(handleGetArchivedArtsResponse)
      .catch(handleGetArchivedArtsError)
  }

  function getUserFolders () {
    $scope.aFolders = []
    $scope.loadingFolders = true
    ArtsService.getUserFolders()
      .then(function (aFolders) {
        $scope.loadingFolders = false
        $scope.aFolders = aFolders
        $scope.folderInEditMode = null
      })
      .catch(function () {
        $scope.loadingFolders = false
      })
  }

  getUserFolders()

  function handleFolderCreateSuccess (oData) {
    $scope.folderForm.newFolderName = ''
    $scope.loadingFolders = false
    $scope.showNewFolderInput = false

    if (!$scope.aFolders) {
      $scope.aFolders = []
    }
    $scope.aFolders.push(oData)
  }

  function handleFolderServiceError () {
    $scope.folderForm.newFolderName = ''
    $scope.loadingFolders = false
    $scope.showNewFolderInput = false

    ToastService.defaultErrorToast()
  }

  $scope._showErrorEmptyFolderName = function () {
    ToastService.showErrorToast($translate.instant('folderNameNotEmpty'))
  }

  $scope.createFolder = function () {
    $scope.loadingFolders = true
    if (!$scope.folderForm.newFolderName || !$scope.folderForm.newFolderName.trim || !$scope.folderForm.newFolderName.trim().length) {
      $scope._showErrorEmptyFolderName()
      return
    }
    ArtsService.createFolder({
      name: $scope.folderForm.newFolderName
    })
      .then(handleFolderCreateSuccess)
      .catch(handleFolderServiceError)
  }

  $scope.deleteFolder = function (oFolder, $event) {
    $event.stopPropagation()
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteFolder'),
      confirmButton: $translate.instant('yes'),
      cancelButton: $translate.instant('no'),
      press: function () {
        $scope.loadingFolders = true
        ArtsService.deleteFolder(oFolder.id)
          .then(getUserFolders)
          .then(() => showOwnArts())
          .catch(handleFolderServiceError)
      }
    })
  }

  $scope.editFolderName = function (oFolder, $event) {
    $event.stopPropagation()
    oFolder.newNameEdit = oFolder.name
    $scope.folderInEditMode = oFolder
  }

  $scope.cancelFolderEdit = function (oFolder, $event) {
    $event.stopPropagation()
    oFolder.newNameEdit = ''
    $scope.folderInEditMode = null
  }

  $scope.saveEditFolderName = function (oFolder, $event) {
    $event.stopPropagation()
    if (!oFolder.newNameEdit || !oFolder.newNameEdit.trim || !oFolder.newNameEdit.trim().length) {
      $scope._showErrorEmptyFolderName()
      return
    }
    ArtsService.updateFolder(oFolder.id, {
      name: oFolder.newNameEdit
    })
      .then(folder => {
        $scope.selectedFolder = folder
        getUserFolders()
      })
      .catch(handleFolderServiceError)
  }

  $scope.isCurrentSelectedFolder = function (oFolder) {
    return $scope.selectedFolderId === oFolder.id
  }

  $scope.showMoveArtToFolderOption = function (oArt) {
    var bShow = $scope.aFolders.length > 0
    if (($scope.aFolders.length === 1 && oArt.folderId !== null) || $scope.artsBeingShown !== 'userDashboardArts') {
      bShow = false
    }
    return bShow
  }

  $scope.handleAllArtsBreadcrumbsPressed = function () {
    if (!$scope.selectedFolderId && $scope.artsBeingShown === 'userDashboardArts') {
      return
    }

    $scope.selectedFolderId = null
    $scope.selectedFolder = null

    showOwnArts()
  }

  $scope.onFolderPress = function (oFolder) {
    $scope.artsBeingShown = 'userDashboardArts'
    $scope.floatingBarLocation = 'artList'
    if ($scope.isFolderInEditMode(oFolder)) {
      return
    }
    if ($scope.isCurrentSelectedFolder(oFolder)) {
      $scope.selectedFolderId = null
      $scope.selectedFolder = null
    } else {
      $scope.selectedFolderId = oFolder.id
      $scope.selectedFolder = oFolder
    }

    ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
      .then(handleGetArtsResponse)
      .catch(handleGetArtsError)
  }

  $scope.isFolderInEditMode = function (oFolder) {
    return $scope.folderInEditMode === oFolder
  }

  $scope.userHasFolders = function () {
    return $scope.aFolders && $scope.aFolders.length
  }

  $scope.showEmptyFolderMsg = function () {
    return !$scope.userHasFolders() && !$scope.showNewFolderInput
  }

  $scope.onImgLoadError = function () {
    return '/assets/img/icons/img-placeholder.png'
  }

  $scope.skipPagingTo = api._skipPagingTo

  $scope.fnFormatterCategory = function (sCategory) {
    return $translate.instant(sCategory)
  }

  $scope.selectArtClicked = function (art, event) {
    const isShiftPressed = event && event.shiftKey

    if ($scope.artsBeingShown !== 'sharedArts') {
      if (art.selected) {
        art.selected = false
        $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== art.id)
      } else {
        if ($scope.selectedTemplates.length === 0) {
          art.firstSelection = true
        }

        if (isShiftPressed) {
          const { selectedTemplates } = SelectMaterialCollectionService.handleShiftClickOnMaterial(art, {
            selectedTemplates: $scope.selectedTemplates,
            selectedCollections: [],
            collection: { templates: $scope.arts },
            disabledTemplatesRule: 'IGNORE'
          })

          $scope.selectedTemplates = selectedTemplates
          return
        }

        art.selected = true
        if (!$scope.selectedTemplates.some(t => t.id === art.id)) {
          $scope.selectedTemplates.push(art)
        }
      }
    }
  }

  $scope.unselectAllAssets = function () {
    api._unselectAllAssets()
  }

  function _unselectAllAssets () {
    $scope.selectedTemplates.forEach(art => {
      art.firstSelection = false
      art.selected = false
    })

    $scope.selectedTemplates = []
  }

  $scope.archiveSelectedArts = function () {
    if (!$scope.selectedTemplates.length) {
      return
    }
    if ($scope.artsBeingShown === 'userArchivedArts') {
      MessageService.warning({
        title: $translate.instant('warning'),
        text: $translate.instant('areYouSureUnarchiveSelectedArts'),
        confirmButton: $translate.instant('unarchive'),
        cancelButton: $translate.instant('cancel'),
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: true,
        press: () => {
          $scope.flags.loading = true
          const ids = $scope.selectedTemplates.map(art => art.id)
          ArtsService.bulkUnarchiveTemplates(ids)
            .then((res) => {
              ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
                .then(() => showOwnArts())
                .then(ToastService.defaultSuccessToast)
                .catch(handleGetArtsError)
            }, () => {
              $scope.flags.loading = false
              ToastService.defaultErrorToast()
            })
        }
      })
    } else {
      MessageService.warning({
        title: $translate.instant('warning'),
        text: $translate.instant('areYouSureArchiveSelectedArts'),
        confirmButton: $translate.instant('archive'),
        cancelButton: $translate.instant('cancel'),
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: true,
        press: () => {
          $scope.flags.loading = true
          const ids = $scope.selectedTemplates.map(art => art.id)
          ArtsService.bulkArchiveTemplates(ids)
            .then((res) => {
              ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop)
                .then(handleGetArtsResponse)
                .then(() => api._unselectAllAssets())
                .then(ToastService.defaultSuccessToast)
                .catch(handleGetArtsError)
            }, () => {
              $scope.flags.loading = false
              ToastService.defaultErrorToast()
            })
        }
      })
    }
  }

  function _skipPagingTo (token, fromParams) {
    $scope.flags.loading = true

    let pageToken = Number(token)

    if (!fromParams || !pageToken) {
      pageToken = isNaN(pageToken) ? 1 : pageToken + 1
    }

    if (pageToken < 1) {
      pageToken = 1
    }

    $scope.currentPage = pageToken
    $scope.indexToken = pageToken - 1

    const page = pageToken !== 1 ? pageToken : null

    $location.search({ ...$state.params, page })

    const iSkip = (pageToken - 1) * $scope.iCurrentTop

    if ($scope.artsBeingShown === 'userArchivedArts') {
      return ArtsService.getArchivedArts($scope.iCurrentTop, iSkip)
        .then(setArtsAndResync)
        .catch(handleGetArtsError)
    } else if ($scope.artsBeingShown === 'sharedArts') {
      return ArtsService.getSharedArts($scope.iCurrentTop, iSkip)
        .then(setArtsAndResync)
        .catch(handleGetArtsError)
    } else {
      return ArtsService.getArts($scope.selectedFolderId, $scope.iCurrentTop, iSkip)
        .then(handleGetArtsResponse)
        .catch(handleGetArtsError)
    }
  }

  function confirmArchiveOrDelete (oArte, domButton, action) {
    ArtsService.getArtCollaborators(oArte.id).then(function (oRes) {
      var sText = (action === 'unarchive') ? $translate.instant('confirmUnarchiveArt')
        : (action === 'archive') ? $translate.instant('areYouSureArchiveArt') : $translate.instant('areYouSureDeleteArt')
      if (oRes.length > 0) {
        sText += '\n' + oRes.length + ' ' + $translate.instant('collaboratorsWillLoseAccess')
      }
      MessageService.warning({
        title: $translate.instant('warning'),
        text: sText,
        cancelButton: $translate.instant('no'),
        confirmButton: $translate.instant('yes'),
        closeOnConfirm: true,
        press: function () {
          domButton.addClass('loading')
          var iIndex = $scope.arts.indexOf(oArte)
          ArtsService[action + 'Art']($scope.arts[iIndex].id)
            .then(function (res) {
              domButton.removeClass('loading')
              $scope.arts.splice(iIndex, 1)
            }, function () {
              domButton.removeClass('loading')
            })
        }
      })
    })
  }

  $scope.archiveArt = function (oArte, event) {
    var domButton = $(event.currentTarget)
    confirmArchiveOrDelete(oArte, domButton, 'archive')
  }

  $scope.unarchiveArt = function (oArte, event) {
    var domButton = $(event.currentTarget)
    confirmArchiveOrDelete(oArte, domButton, 'unarchive')
  }

  $scope.addFolder = function () {
    $scope.showNewFolderInput = true
  }

  $scope.discardNewFolder = function () {
    $scope.showNewFolderInput = false
  }

  $scope.shareInternally = function (oArt) {
    api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
      const shareArtDialog = UdsModalService.createModal({
        controller: ShareArtDialogController,
        modalName: 'shareArtDialog',
        data: {
          art: oArt
        }
      })

      shareArtDialog.open()
    })
  }

  $scope.shouldShowIcon = function (art, icon) {
    return art.shared_art.some(shared => shared && shared.socialType === icon)
  }

  $scope.createBlankArt = function (params) {
    api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
      const artSizeDialog = UdsModalService.createModal({
        controller: ArtSizeDialogController,
        modalName: 'artSizeDialog'
      })

      artSizeDialog.open()
    })
  }

  function _keepOnSamePage (stateParams) {
    if (stateParams.page) {
      return api._skipPagingTo(stateParams.page, true)
    } else {
      return api._skipPagingTo(0)
    }
  }

  function _checkIfPageExists (count, top) {
    if (!count) {
      return
    }

    const paginationSize = Math.ceil(count / top)

    if ($scope.currentPage > paginationSize) {
      api._skipPagingTo(1, true)
      ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
    }
  }

  function _openArtApproval (artId) {
    ArtsService.getArtDetailById(artId).then(art => {
      AssetPreviewService.openAssetPreview({
        asset: art,
        getPreviewAssets: $scope.getPreviewAssets,
        location: 'materialsApproval'
      })
    })
  }

  $scope.getPreviewAssets = () => {
    return Promise.resolve({
      assets: $scope.arts || [],
      count: $scope.arts?.length || 0
    })
  }

  function _moveArtToFolder (template, folders, skipEventEmit) {
    return api.getMoveArtToFolderController().then(({ MoveArtToFolderController }) => {
      return ModalService.showModal({
        templateId: 'moveArtToFolderController.html',
        templateUrl: '/arts/dialogs/move-art-to-folder/move-art-to-folder-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveArtToFolderController,
        data: {
          templates: [template]
        }
      }).then(info => {
        if (info && info.changed) {
          $scope.$emit('reload-arts-page')
        }

        return info.changed
      })
    })
  }

  function _handleKeyboardNavigation () {
    document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
  }

  function _handleNavigateThroughKeyboard (ev) {
    const isAssetPreviewOpen = AssetPreviewService.assetPreviewIsOpen()

    if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length) || isAssetPreviewOpen) {
      return
    }

    SelectMaterialCollectionService.handleNavigateThroughKeyboard(ev, {
      selectedTemplates: $scope.selectedTemplates,
      selectedCollections: [],
      scope: $scope,
      collection: { templates: $scope.arts },
      disabledTemplatesRule: 'IGNORE'
    })
  }
}
